export enum MessageProfileIdSearchOptionEnum {
  AllProfilesSentEmail,
  AllProfilesOpenedEmail,
  AllProfilesNotOpenEmail,
  AllProfilesClickOnLink,
  AllProfilesNotClickOnLink,
}
